import { CSRF } from '../utils/CSRF'
import { BaseRepository } from './BaseRepository'

export type ScaffoldDemoClipResponse = {
  status: 'success'
  project: any
  pod: any
  segments: any
}
export class OnboardingRepository extends BaseRepository {
  scaffoldDemoClipIntoDefaultProject() {
    return super.getHttpClientInstance().post<ScaffoldDemoClipResponse>(
      '/scaffold_demo_clip',
      {},
      {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  submitUseCases = async (selectedUseCases: string[]) => {
    const res = await super.getHttpClientInstance().post(
      '/hub/submit_use_cases',
      { use_cases: selectedUseCases },
      {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
    return res.data
  }
}
